(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ==========================================
     DYNAMIC SEARCH PLACEHOLDER ANIMATION 
     ========================================== */
  document.addEventListener('DOMContentLoaded', function() {
    const spaServices = [
      "Deep Tissue Massage...",
      "Swedish Massage...",
      "Aromatherapy...",
      "Hot Stone Massage...",
      "Couples Spa Packages..."
    ];
    
    const wrappers = document.querySelectorAll('.animated-placeholder');
    
    if (wrappers.length > 0) {
      let termIndex = 0;
      setInterval(() => {
        termIndex = (termIndex + 1) % spaServices.length;
        const nextText = 'Search for ' + spaServices[termIndex];
        
        wrappers.forEach(container => {
          const current = container.querySelector('.ph-active');
          const nextEl = document.createElement('span');
          nextEl.className = 'ph-text ph-down';
          nextEl.textContent = nextText;
          container.appendChild(nextEl);
          
          void nextEl.offsetWidth;
          
          if (current) current.classList.replace('ph-active', 'ph-up');
          nextEl.classList.replace('ph-down', 'ph-active');
          
          setTimeout(() => { 
            if (current) current.remove(); 
          }, 400);
        });
      }, 2000); 
    }
  });

  /* ==========================================
     FLAWLESS STICKY HEADER LOGIC
     ========================================== */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.stickyType = this.getAttribute('data-sticky-type');
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = 100;

      if (scrollTop > scrollThreshold) {
        this.classList.add('scrolled-past-header');
      } else {
        this.classList.remove('scrolled-past-header');
      }

      if (this.stickyType === 'on-scroll-up' && scrollTop > scrollThreshold) {
        if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold + 50) {
          this.style.transform = 'translateY(-100%)';
        } else if (scrollTop < this.currentScrollTop) {
          this.style.transform = 'translateY(0)';
        }
      } else {
        this.style.transform = 'translateY(0)';
      }

      this.currentScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
